import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = localStorage.getItem('token');
    const currentUrl = state.url;
    if (token && token !== 'undefined' && token !== 'null') {
      if (currentUrl === '/login') {
        this.router.navigate(['/dashboard']);
        return true;
      }
      return true;
    }
    if (currentUrl === '/login') {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}
